import React from 'react'
import { ToggleButton, type ToggleButtonProps } from '@mui/material'
import { UserGroupIcon, UserIcon } from '@heroicons/react/24/outline'

import { GoalScope } from '../../../../../../../pure-js/types/CoachTypes'
import { useTranslation } from '../../../../../shared/hooks/useIntractionTranslate'
import { COACH_FOCUS_ICON_SIZE_PX, COACH_FOCUS_LABEL_KEYS } from '../coachPageStyles'

const FOCUS_ICONS: Record<GoalScope, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  [GoalScope.INDIVIDUAL]: UserIcon,
  [GoalScope.LEADERSHIP]: UserGroupIcon
}

export type CoachFocusOptionProps = Omit<ToggleButtonProps, 'value'> & {
  value: GoalScope
}

/** One side of the focus switch: the icon of the focus and its name. */
export const CoachFocusOption: React.FC<CoachFocusOptionProps> = ({ value, ...toggleButtonProps }) => {
  const { t } = useTranslation()
  const Icon = FOCUS_ICONS[value]

  return (
    <ToggleButton value={value} {...toggleButtonProps}>
      <Icon width={COACH_FOCUS_ICON_SIZE_PX} height={COACH_FOCUS_ICON_SIZE_PX} />
      {t(COACH_FOCUS_LABEL_KEYS[value])}
    </ToggleButton>
  )
}
